import { defineComponent, onBeforeMount, ref } from 'vue';
import useTransactionsStore from '@/store/modules/transactions';
import router from '@/router';
import { storeToRefs } from 'pinia';
import { useAuthStore } from '@/store/modules/auth';
import { AuthTypes } from '@/types/auth';
import { SwitchPill } from '@yellowcard/components-library-vue3';
import { MIXPANEL_EVENTS, trackEvent } from '@/utils/mixpanel';
export default defineComponent({
    name: 'SellCrypto',
    components: {
        SwitchPill,
    },
    setup() {
        const authStore = useAuthStore();
        const { isLoggedIn, currentStep: authCurrentStep, standaloneAuthFlow, partnerId, } = storeToRefs(authStore);
        const transactionsStore = useTransactionsStore();
        const { showSideMenu } = storeToRefs(transactionsStore);
        const fromHome = ref(false);
        onBeforeMount(() => {
            const backUrl = router.options.history.state.back;
            const route = router.resolve({ path: `${backUrl}` });
            fromHome.value = route.path === '/';
        });
        const onKeyPress = () => {
            console.log('key pressed');
        };
        const openSideMenu = () => {
            showSideMenu.value = true;
        };
        const onSwitchOptionSelected = async (evt) => {
            // console.log(lastRoute.value.path)
            switch (evt.target.innerText) {
                case 'Buy':
                    await router.push('/transact');
                    break;
                case 'Sell':
                    await router.push('/sell');
                    break;
                default:
            }
        };
        const signIn = () => {
            trackEvent(MIXPANEL_EVENTS.SIGNIN.SIGN_IN, {
                partner: partnerId.value,
            });
            router.push('/auth');
            authCurrentStep.value = AuthTypes.AuthSteps.AUTH_1;
            standaloneAuthFlow.value = true;
        };
        const onBackClickListener = () => {
            if (fromHome.value) {
                router.push('/');
            }
            else {
                router.push('/transact');
            }
        };
        return {
            onKeyPress,
            openSideMenu,
            isLoggedIn,
            onSwitchOptionSelected,
            onBackClickListener,
            signIn,
            fromHome,
        };
    },
});
